'use strict'

import axios from '@/plugins/axios-instance.js'
// import * as type from './types'

const url =
  'https://5w51zrlbsl.execute-api.eu-west-1.amazonaws.com/prod/organizations'

const actions = {

  // Create new organizations (user is part of this organization, which must confirm)
  createOrganization ({ commit }, organization) {
    commit('START_OPERATION')
    axios
      .put(url, organization)
      .then(resp => {
        commit('CREATE_ORGANIZATION', {
          id: resp.data.id,
          organization: organization
        })
      })
      .catch(error => {
        commit('OPERATION_ERROR', {
          error
        })
      })
  },

  // Add new managed organizations (not owned, like vendor or customer)
  addOrganization ({ commit, dispatch }, data) {
    commit('START_OPERATION')
    axios
      .post(url, data.organization)
      .then(resp => {
        commit('ADD_ORGANIZATION', {
          id: resp.data.aggregateID,
          organization: data.organization
        })
        let description = data.description
        description.organizationID = resp.data.aggregateID
        let groups = data.groups
        groups.organizationID = resp.data.aggregateID
        dispatch('changeOrganizationDescription', description)
        dispatch('addOrganizationToGroups', groups)
      })
      .catch(error => {
        commit('OPERATION_ERROR', {
          error
        })
      })
  },

  // Remove managed organization
  removeOrganization ({ commit }, organizationID) {
    commit('START_OPERATION')
    axios
      .post(url + '/' + organizationID)
      .then(resp => {
        commit('REMOVE_ORGANIZATION', {
          id: resp.data.aggregateID
        })
      })
      .catch(error => {
        commit('OPERATION_ERROR', {
          error
        })
      })
  },

  // Connect other organization in wereldo
  connectOrganization ({ commit }, organizationID) {
    commit('START_OPERATION')
    axios
      .post(url + '/' + organizationID + '/connect')
      .then(resp => {
        commit('CONNECT_ORGANIZATION', {
          id: resp.data.aggregateID
        })
      })
      .catch(error => {
        commit('OPERATION_ERROR', {
          error
        })
      })
  },

  // Disconnect connected organization in wereldo
  disconnectOrganization ({ commit }, organizationID) {
    commit('START_OPERATION')
    axios
      .post(url + '/' + organizationID + '/disconnect')
      .then(resp => {
        commit('DISCONNECT_ORGANIZATION', {
          id: resp.data.aggregateID
        })
      })
      .catch(error => {
        commit('OPERATION_ERROR', {
          error
        })
      })
  },

  // TODO: implement
  // Verify that person who claims organization account is within organization
  // verifyOrganization ({ commit }, verificationCode) {
  //   commit('START_OPERATION')
  //   axios
  //     .post(url + '/verify', verificationCode)
  //     .then(resp => {
  //       commit('VERIFY_ORGANIZATION', {
  //         id: resp.data.id
  //       })
  //     })
  //     .catch(error => {
  //       commit('OPERATION_ERROR', {
  //         error
  //       })
  //     })
  // },

  // Change organization name
  changeOrganizationName ({ commit }, data) {
    commit('START_OPERATION')
    axios
      .post(url + '/' + data.organizationID + '/name', { name: data.name })
      .then(resp => {
        commit('CHANGE_ORGANIZATION_NAME', {
          id: resp.data.aggregateID,
          name: data.name
        })
      })
      .catch(error => {
        commit('OPERATION_ERROR', {
          error
        })
      })
  },

  // Change organization address
  changeOrganizationAddress ({ commit }, data) {
    commit('START_OPERATION')
    axios
      .post(url + '/' + data.organizationID + '/address', { address: data.address })
      .then(resp => {
        commit('CHANGE_ORGANIZATION_ADDRESS', {
          id: resp.data.aggregateID,
          address: data.address
        })
      })
      .catch(error => {
        commit('OPERATION_ERROR', {
          error
        })
      })
  },

  // Change organization description
  changeOrganizationDescription ({ commit }, data) {
    if (data.withoutStart) {
      commit('START_OPERATION')
    }
    axios
      .post(url + '/' + data.organizationID + '/description', { description: data.description })
      .then(resp => {
        commit('CHANGE_ORGANIZATION_DESCRIPTION', {
          id: resp.data.aggregateID,
          description: data.description
        })
      })
      .catch(error => {
        commit('OPERATION_ERROR', {
          error
        })
      })
  },

  // Add organization to groups
  addOrganizationToGroups ({ commit }, data) {
    if (data.withoutStart) {
      commit('START_OPERATION')
    }
    axios
      .post(url + '/' + data.organizationID + '/groups', { groups: data.groups })
      .then(resp => {
        commit('ADD_ORGANIZATION_TO_GROUPS', {
          id: resp.data.aggregateID,
          groups: data.groups
        })
      })
      .catch(error => {
        commit('OPERATION_ERROR', {
          error
        })
      })
  },

  // Remove organization from groups
  removeOrganizationFromGroups ({ commit }, data) {
    commit('START_OPERATION')
    axios
      .post(url + '/' + data.organizationID + '/groups', { groups: data.groups })
      .then(resp => {
        commit('REMOVE_ORGANIZATION_FROM_GROUPS', {
          id: resp.data.aggregateID,
          groups: data.groups
        })
      })
      .catch(error => {
        commit('OPERATION_ERROR', {
          error
        })
      })
  },

  // Get organization detail
  async getOrganization ({ commit }, organizationID) {
    commit('START_OPERATION')
    await axios
      .get(`${url}/${organizationID}`)
      .then(resp => {
        commit('GET_ORGANIZATION', {
          payload: resp.data
        })
      })
      .catch(error => {
        commit('OPERATION_ERROR', {
          error
        })
      })
  },

  // List locations of the organizations
  listLocations ({ commit, state, dispatch }, organizationID) {
    commit('START_OPERATION')
    // fetch organization of location if not defined (but should be always defined)
    if (state.data[organizationID] === undefined) {
      dispatch('getOrganization', organizationID)
    }
    axios
      .get(`${url}/${organizationID}/locations`)
      .then(resp => {
        commit('GET_LOCATIONS_LIST', {
          payload: resp.data,
          organizationID: organizationID
        })
      })
      .catch(error => {
        commit('OPERATION_ERROR', {
          error
        })
      })
  },

  // Get location detail
  async getLocation ({ commit, state, dispatch }, data) {
    commit('START_OPERATION')
    // fetch organization of location if not defined (but should be always defined)
    if (state.data[data.organizationID] === undefined) {
      await dispatch('getOrganization', data.organizationID)
    }
    await axios
      .get(`${url}/${data.organizationID}/locations/${data.locationID}`)
      .then(resp => {
        commit('GET_LOCATION_DETAIL', {
          payload: resp.data,
          organizationID: data.organizationID
        })
      })
      .catch(error => {
        commit('OPERATION_ERROR', {
          error
        })
      })
  },

  // List contacts of the organizations
  listContacts ({ commit, state, dispatch }, organizationID) {
    commit('START_OPERATION')
    // fetch organization of contact if not defined (but should be always defined)
    if (state.data[organizationID] === undefined) {
      dispatch('getOrganization', organizationID)
    }
    axios
      .get(`${url}/${organizationID}/contacts`)
      .then(resp => {
        commit('GET_CONTACTS_LIST', {
          payload: resp.data,
          organizationID: organizationID
        })
      })
      .catch(error => {
        commit('OPERATION_ERROR', {
          error
        })
      })
  },

  // Get contact detail
  async getContact ({ commit, state, dispatch }, data) {
    commit('START_OPERATION')
    // fetch organization of contact if not defined (but should be always defined)
    if (state.data[data.organizationID] === undefined) {
      dispatch('getOrganization', data.organizationID)
    }
    await axios
      .get(`${url}/${data.organizationID}/contacts/${data.contactID}`)
      .then(resp => {
        commit('GET_CONTACT_DETAIL', {
          payload: resp.data,
          organizationID: data.organizationID
        })
      })
      .catch(error => {
        commit('OPERATION_ERROR', {
          error
        })
      })
  }

}

export default actions
